import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiImportContactsRequest extends ApiRequestor {
  $import (payload) {
    return this.$http('POST', 'ticketContacts/import', {payload});
  }
}
